/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Priority_ConfirmInputs */

const en_explorer_info_priority_confirm = /** @type {(inputs: Explorer_Info_Priority_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save Priority`)
};

const fr_explorer_info_priority_confirm = /** @type {(inputs: Explorer_Info_Priority_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save Priority`)
};

const de_explorer_info_priority_confirm = /** @type {(inputs: Explorer_Info_Priority_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save Priority`)
};

const it_explorer_info_priority_confirm = /** @type {(inputs: Explorer_Info_Priority_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save Priority`)
};

const ru_explorer_info_priority_confirm = /** @type {(inputs: Explorer_Info_Priority_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save Priority`)
};

const es_explorer_info_priority_confirm = /** @type {(inputs: Explorer_Info_Priority_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save Priority`)
};

const zh_cn2_explorer_info_priority_confirm = /** @type {(inputs: Explorer_Info_Priority_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save Priority`)
};

const ja_explorer_info_priority_confirm = /** @type {(inputs: Explorer_Info_Priority_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save Priority`)
};

const hi_explorer_info_priority_confirm = /** @type {(inputs: Explorer_Info_Priority_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save Priority`)
};

const pt_pt2_explorer_info_priority_confirm = /** @type {(inputs: Explorer_Info_Priority_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save Priority`)
};

/**
* | output |
* | --- |
* | "Save Priority" |
*
* @param {Explorer_Info_Priority_ConfirmInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_priority_confirm = /** @type {((inputs?: Explorer_Info_Priority_ConfirmInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Priority_ConfirmInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_info_priority_confirm(inputs)
	if (locale === "de") return de_explorer_info_priority_confirm(inputs)
	if (locale === "it") return it_explorer_info_priority_confirm(inputs)
	if (locale === "ru") return ru_explorer_info_priority_confirm(inputs)
	if (locale === "es") return es_explorer_info_priority_confirm(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_info_priority_confirm(inputs)
	if (locale === "ja") return ja_explorer_info_priority_confirm(inputs)
	if (locale === "hi") return hi_explorer_info_priority_confirm(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_info_priority_confirm(inputs)
	return en_explorer_info_priority_confirm(inputs)
});